import { WebHaptics } from "web-haptics"

class HapticsService {
    private haptics: WebHaptics | null = null
    private initializedListener = false
    private isDesktop = false

    public init() {
        if (this.initializedListener || typeof window === "undefined") return
        this.initializedListener = true

        // Check if device is desktop (fine pointer) for debug audio
        this.isDesktop = window.matchMedia("(pointer: fine)").matches

        // Initialize the library immediately so it sets up its own iOS unlock listeners
        try {
            this.haptics = new WebHaptics({
                debug: false,
                showSwitch: false,
            })
        } catch (error) {
            console.warn("Failed to initialize WebHaptics instance", error)
        }

        this.initGlobalListener()
    }

    private initGlobalListener() {
        if (typeof document === "undefined") return

        // pointerdown is often faster on mobile and avoids click-swallowing issues.
        // However, to prevent double firing with click, we can track timestamps or just use one.
        // Touchstart is usually the best for mobile responsiveness.
        let lastTrigger = 0
        const handleInteraction = (e: Event) => {
            const now = Date.now()
            if (now - lastTrigger < 100) return // debounce double triggers from touch and click

            const target = e.target as HTMLElement
            const isClickable = target.closest(
                'a, button, [role="button"], [role="tab"], [tabindex], .cursor-pointer',
            )
            const isInput = target.closest("input, textarea")
            const shouldSkip = target.closest('[data-no-haptic="true"]')

            if (isClickable && !isInput && !shouldSkip) {
                lastTrigger = now
                this.trigger("nudge")
            }
        }

        document.addEventListener("pointerdown", handleInteraction, { capture: true })
        document.addEventListener("click", handleInteraction, { capture: true })
    }

    /**
     * Triggers a specific haptic pattern.
     * @param pattern The built-in preset name or custom pattern array
     */
    public trigger(pattern: "success" | "nudge" | "error" | "buzz" | "medium" | number | any[] | any) {
        if (!this.haptics) return

        // Map legacy/invalid patterns
        if (pattern === "medium") pattern = "nudge"

        try {
            this.haptics.trigger(pattern)
        } catch (e) {
            console.warn("Haptic trigger failed", e)
        }
    }
}

export const Haptics = new HapticsService()
